import React, { useEffect, ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import {
  Box,
  Typography,
  Paper,
  Container,
  CircularProgress,
} from "@mui/material";

const Logout = (): ReactElement => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();

    navigate("/auth", { replace: true });
  }, [logout, navigate]);

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            borderRadius: 2,
          }}
        >
          <CircularProgress sx={{ mb: 2 }} />
          <Typography
            component="h2"
            variant="h5"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Logging out...
          </Typography>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              textAlign: "center",
              color: "text.secondary",
            }}
          >
            Please wait while we sign you out.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Logout;
